export const COMO_FUNCIONA_INTRO = 'Do edital aberto até você começar a atuar como credenciado no Pará — veja cada etapa do processo.'

export const COMO_FUNCIONA_STEPS = [
  {
    titulo: 'Leia o edital com atenção',
    descricao: 'Baixe o documento oficial e confira requisitos, documentos necessários, critérios de avaliação e etapas do processo.'
  },
  {
    titulo: 'Se inscreva no edital',
    descricao: 'Preencha o formulário, anexe a documentação exigida e confirme o envio dentro do prazo do edital.',
    observacao: 'Obs: Revise todos os anexos antes de enviar — correções podem atrasar a análise.'
  },
  {
    titulo: 'Acompanhe a análise documental',
    descricao: 'Pela área do candidato, acompanhe se sua documentação foi recebida, está em análise ou se há pendências a resolver.',
    observacao: 'Obs: Você também será avisado por e-mail caso seja necessário algum documento ou informação complementar.'
  },
  {
    titulo: 'Aguarde o resultado',
    descricao: 'O ITERPA publica a lista de aprovados. Você será notificado e poderá consultar o resultado na área do candidato.'
  },
  {
    titulo: 'Seja homologado e credenciado',
    descricao: 'Realize o curso do ITERPA e anexe o certificado na plataforma para ser homologado e aparecer na lista pública de credenciados.'
  },
  {
    titulo: 'Apareça na lista pública',
    descricao: 'Seu perfil fica visível na página de Credenciados do portal, onde interessados buscam profissionais habilitados no Pará.'
  },
  {
    titulo: 'Comece a trabalhar',
    descricao: 'Interessados entram em contato diretamente para contratar seus serviços de georreferenciamento ou vistoria nos processos de regularização fundiária.',
    final: true
  }
]

export const FEATURE_CARDS = [
  {
    icon: require('@/assets/icons/editais/feature-inscricao-digital.svg'),
    title: 'Inscrição digital',
    description: 'Envie sua documentação pelo sistema SICARF sem precisar comparecer ao ITERPA.'
  },
  {
    icon: require('@/assets/icons/editais/feature-isento-taxas.svg'),
    title: 'Isento de taxas',
    description: 'O credenciamento é gratuito. Nenhuma taxa de inscrição, análise ou certificação.'
  },
  {
    icon: require('@/assets/icons/editais/feature-atuacao-estadual.svg'),
    title: 'Atuação estadual',
    description: 'Credencial válida para todos os municípios do Pará onde o ITERPA tem atuação.'
  }
]

export const EDITAL_CONTENT = {
  GEOMENSOR: {
    titulo: 'Geomensor',
    descricao: 'Credenciamento de profissionais habilitados para execução de serviços de georreferenciamento e elaboração de plantas e memoriais descritivos vinculados aos processos de regularização fundiária no âmbito do ITERPA.',
    modalidade: 'Georreferenciamento'
  },
  VISTORIADOR: {
    titulo: 'Vistoriador',
    descricao: 'Seleção de profissionais para realização de vistorias técnicas em imóveis rurais e urbanos, com emissão de laudos vinculados aos processos de regularização fundiária do SICARF.',
    modalidade: 'Vistoria de Imóveis'
  }
}

export const FAQ_ITEMS = [
  {
    pergunta: 'Quem pode se credenciar como geomensor ou vistoriador?',
    resposta: 'Profissionais com formação e registro compatíveis com a modalidade do edital, conforme requisitos descritos no documento oficial de credenciamento.'
  },
  {
    pergunta: 'Posso me credenciar nas duas modalidades ao mesmo tempo?',
    resposta: 'Sim, desde que atenda aos requisitos específicos de cada edital e envie a documentação correspondente para cada modalidade.'
  },
  {
    pergunta: 'O credenciamento tem validade?',
    resposta: 'A validade do credenciamento está vinculada ao período de vigência do edital e às regras estabelecidas pelo ITERPA.'
  },
  {
    pergunta: 'Como acompanho o andamento da minha inscrição?',
    resposta: 'Após realizar a inscrição, você pode acompanhar o status pelo sistema SICARF, na área do credenciado.'
  },
  {
    pergunta: 'Há taxa de inscrição?',
    resposta: 'Não. O processo de credenciamento é gratuito, sem cobrança de taxa de inscrição, análise ou certificação.'
  },
  {
    pergunta: 'O que acontece após ser credenciado?',
    resposta: 'Após aprovação, o profissional passa a integrar o cadastro de credenciados e pode ser convocado para prestar serviços conforme demanda do ITERPA.'
  },
  {
    pergunta: 'Como são calculados os honorários pelos serviços prestados?',
    resposta: 'Os honorários seguem as tabelas e critérios definidos pelo ITERPA para cada tipo de serviço prestado no âmbito da regularização fundiária.'
  }
]

export const NAVBAR_CONSULTAS = [
  { label: 'Autenticidade', path: '/autenticidade' },
  { label: 'Legislação', path: '/legislacao' },
  { label: 'Homologação', path: '/homologacao' },
  { label: 'Transparência', path: '/transparencia' },
  { label: 'Publicação', path: '/publicacao' },
  {
    label: 'Acervo Fundiário Público',
    href: 'https://arcgisportal.iterpa.pa.gov.br/portal/apps/webappviewer/index.html?id=d805213cbc1c486d8bb7a1cf7bf3727f',
    external: true
  },
  {
    label: 'Painel de conflitos',
    href: 'https://arcgisportal.iterpa.pa.gov.br/portal/home/webmap/viewer.html?webmap=c42097f46ab0422eade4d9ee2ac45b6c',
    external: true
  }
]

export const NAVBAR_LINKS = [
  { label: 'Início', path: '/' },
  { label: 'Informações', path: '/informacoes' },
  { label: 'Fale conosco', path: '/#contato' }
]

export const FOOTER_COLUNAS = [
  {
    titulo: 'BAIXAR SICARF',
    links: [
      { label: 'Como baixar Módulo Offline', path: '/download' },
      { label: 'Como enviar o cadastro', path: '/enviar-cadastro' }
    ]
  },
  {
    titulo: 'MANUAL DO USUÁRIO',
    links: [
      { label: 'Observações importantes', path: '/informacoes/observacoes' },
      { label: 'Documentos necessários', path: '/informacoes/documentos-necessarios' },
      { label: 'Manual online', path: '/' },
      { label: 'Manual offline', path: '/' },
      { label: 'Perguntas frequentes', path: '/informacoes/perguntas-frequentes' }
    ]
  },
  {
    titulo: 'TRANSPARÊNCIA',
    links: [
      { label: 'Nossos números', path: '/transparencia#nossos-numeros' },
      { label: 'Consulta de processos', path: '/transparencia#consulta-de-processos' },
      { label: 'Fale conosco', path: '/#contato' }
    ]
  }
]

export const FOOTER_REDES_SOCIAIS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/governopara/',
    icon: require('@/assets/icons/editais/instagram.svg')
  },
  {
    label: 'X',
    href: 'https://x.com/governopara',
    icon: require('@/assets/icons/editais/twitter-x.svg')
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/governopara',
    icon: require('@/assets/icons/editais/facebook.svg')
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/channel/UCH5UGma6GF1zbrBRqi8Aifw',
    icon: require('@/assets/icons/editais/youtube.svg')
  }
]
